import Axios from "../../../axios-interceptor";
import { loginApiConstants } from "../../../constants/AdminApiConstants";

export async function loginUser(params) {

  return await Axios.post(loginApiConstants.LOGIN_USER, params);
}
